/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/ip_count" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdIpCount } from "./constants";
import type { EmailIpWarmingAppGroupIdIpCountParams, EmailIpWarmingAppGroupIdIpCountResult } from "./types";
import { isEmailIpWarmingAppGroupIdIpCountResult } from "./validators";

export const getEmailIpWarmingAppGroupIdIpCount = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdIpCount,
  (
    signal: AbortSignal,
    { appGroupId, domain }: EmailIpWarmingAppGroupIdIpCountParams
  ): Promise<EmailIpWarmingAppGroupIdIpCountResult> => {
    return fetch(
      `/email/ip_warming/${appGroupId}/ip_count`,
      "GET",
      { domain },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isEmailIpWarmingAppGroupIdIpCountResult
);
